import { Loader2 } from 'lucide-react';
import PostUploadSuccess from '@/components/Illustrations/PostUploadSuccess';
import { TextShimmer } from '@/components/ui/text-shimmer';

function PostStatus({ isLoading }: { isLoading: boolean }) {
  if (isLoading) {
    return (
      <div className="text-center space-y-4">
        <TextShimmer className="text-4xl font-bold">Processing </TextShimmer>
        <div className="w-48 h-48 mx-auto flex items-center justify-center">
          <Loader2 className="w-16 h-16 animate-spin text-primary" />
        </div>
        <h3 className="text-2xl font-semibold">Please wait</h3>
        <p className="text-muted-foreground">
          We&apos;re processing your data. This may take a moment.
        </p>
      </div>
    );
  }

  return (
    <div className="text-center space-y-12">
      <h2 className="text-4xl font-bold">Congratulations!!</h2>
      <div className="w-48 h-auto mx-auto">
        <PostUploadSuccess />
      </div>
      <h3 className="text-2xl font-semibold">
        Project has been submitted for Review 🎉
      </h3>
      <p className="text-slate-900 text-xl">
        Your project will be published once the review is done.
      </p>
    </div>
  );
}

export default PostStatus;
